import {faCauldron} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Text from 'components/Text/Text';
import CountryWordTooltip from 'pages/dashboard/CountryWordTooltip/CountryWordTooltip';
import {cutWord} from 'utils/helpers/cutWord';

interface ITopBreweryProps {
  breweryLogo: string | null;
  name: string;
  kind: string;
  country: string;
}

const TopBrewery = ({breweryLogo, name, kind, country}: ITopBreweryProps) => {
  const cutLength = 10;
  const isWordFitting = country.length <= cutLength;

  return (
    <div className="manager-page__top-single">
      <div className="manager-page__single-wrapper">
        <div className="manager-page__single-title">
          {breweryLogo ? (
            <img className="manager-page__single-image" src={breweryLogo} alt={`${name} brewery`} />
          ) : (
            <div className="manager-page__single-image-placeholder">
              <FontAwesomeIcon icon={faCauldron} />
            </div>
          )}

          <p>{name}</p>
        </div>
        <div className="manager-page__single-kind">{kind}</div>
        <div className="manager-page__single-country">
          <Text
            tag="span"
            className={`manager-page__country-text ${isWordFitting ? 'manager-page__country-text--no-tooltip' : ''}`}
          >
            {cutWord(country, cutLength)}
          </Text>
          <CountryWordTooltip countryName={country} />
        </div>
      </div>
    </div>
  );
};

export default TopBrewery;
